import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gobig_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatMoney = (amount, currency = "AUD") => {
  const code = (currency || "AUD").toUpperCase();
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: code,
    currencyDisplay: "narrowSymbol",
  }).format(amount);
};
